import { render, staticRenderFns } from "./DataEementInfo.vue?vue&type=template&id=ab6bacc8&scoped=true&"
import script from "./DataEementInfo.vue?vue&type=script&lang=js&"
export * from "./DataEementInfo.vue?vue&type=script&lang=js&"
import style0 from "./DataEementInfo.vue?vue&type=style&index=0&id=ab6bacc8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab6bacc8",
  null
  
)

export default component.exports